import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router'
import { Button } from 'antd'
import { apiContext } from 'services/ApiContext'

const OrganizationAdminBtn = () => {
  const { user } = useContext(apiContext)
  const { group, userId } = user || {}
  const { push } = useHistory()
  if (!group || group.owner.userId !== userId) return null

  return (
    <Button className="mr-3" type="primary" onClick={() => push('/group')}>
      <FormattedMessage id="topBar.menu.organization" />
      <span className="ml-1 fa fa-sitemap" />
    </Button>
  )
}

export default OrganizationAdminBtn
